export default {
  setTestCounts: (state, payload) => {
    state.testCounts = payload;
  },
  setProjects: (state, payload) => {
    state.projects = payload;
  },
  setIsAllProjects: (state, payload) => {
    state.isallprojects = payload;
  },
  setTimeRange: (state, payload) => {
    state.timeRange = payload;
  },
};
